import { render, staticRenderFns } from "./LdsLoading.vue?vue&type=template&id=06bb9a74&scoped=true&"
import script from "./LdsLoading.vue?vue&type=script&lang=js&"
export * from "./LdsLoading.vue?vue&type=script&lang=js&"
import style0 from "./LdsLoading.vue?vue&type=style&index=0&id=06bb9a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb9a74",
  null
  
)

export default component.exports